import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cd3b1a38")

_pushScopeId("data-v-cd3b1a38")
const _hoisted_1 = { class: "emoji-panel" }
const _hoisted_2 = { class: "emoji-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reactions.emojilist, (icon, type) => {
        return (_openBlock(), _createBlock("div", {
          class: "emoji",
          key: type,
          onClick: ($event: any) => (_ctx.animate(type))
        }, [
          _createVNode("span", {
            class: {animate:!!~_ctx.animationTimeouts[type], color:_ctx.reactions.localReactions[type]}
          }, _toDisplayString(icon), 3)
        ], 8, ["onClick"]))
      }), 128))
    ])
  ]))
})